export const ALERT_STATUS_ID = {
  ON: 1,
  OFF: 0,
}
